import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Users, Heart, Clock } from 'lucide-react';
export function AboutPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-140">
      <Header data-id="element-141" />

      {/* Hero Section */}
      <section className="relative bg-gray-50 py-24 px-6 lg:px-8 overflow-hidden" data-id="element-142">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-600 opacity-5 -skew-x-12 transform origin-top-right translate-x-1/4" data-id="element-143" />

        <div className="max-w-7xl mx-auto relative z-10" data-id="element-144">
          <div className="max-w-3xl" data-id="element-145">
            <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-146">
              <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-147">
                Who We Are
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black tracking-tighter text-black mb-8 leading-none" data-id="element-148">
              FAMILY OWNED. <br data-id="element-149" />
              <span className="text-slate-600" data-id="element-150">NATIONWIDE</span> REACH.
            </h1>
            <p className="text-xl text-gray-700 font-medium leading-relaxed max-w-2xl" data-id="element-151">
              Raven Advisors is more than just a real estate company. We are a
              family-owned business dedicated to helping homeowners find fast,
              fair solutions for their property needs.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 px-6 lg:px-8 bg-white relative" data-id="element-152">
        <div className="max-w-4xl mx-auto" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-black text-black mb-6 tracking-tight uppercase" data-id="element-154">
            Our Story
          </h2>
          <div className="w-20 h-2 bg-slate-600 mb-8" data-id="element-155" />

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-156">
            <p data-id="element-157">
              Founded on the principles of integrity and transparency, Raven
              Advisors started as a small family operation with a simple
              mission: to make selling a home as stress-free as possible.
            </p>
            <p data-id="element-158">
              We understood that traditional real estate listings aren't for
              everyone. Whether facing foreclosure, dealing with an inherited
              property, or simply needing to relocate quickly, homeowners needed
              a reliable alternative.
            </p>
            <p data-id="element-159">
              Today, we've grown into a nationwide purchasing company, but our
              core values remain the same. We treat every client like family,
              offering fair cash prices and closing on your timeline, not ours.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 px-6 lg:px-8 bg-black text-white relative overflow-hidden" data-id="element-160">
        {/* Diagonal Divider */}
        <div className="absolute top-0 left-0 w-full h-16 bg-white" style={{
        clipPath: 'polygon(0 0, 100% 0, 100% 100%)'
      }} data-id="element-161" />

        <div className="max-w-7xl mx-auto relative z-10 mt-8" data-id="element-162">
          <div className="text-center mb-16" data-id="element-163">
            <h2 className="text-3xl md:text-5xl font-black mb-4 uppercase tracking-tight" data-id="element-164">
              Our Core Values
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-165">
              The principles that guide every interaction and transaction we
              make.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-166">
            {[{
            icon: <Users className="w-10 h-10 text-slate-600" data-id="element-167" />,
            title: 'FAMILY FIRST',
            desc: 'We approach every situation with empathy and respect, treating you as we would our own family.'
          }, {
            icon: <Clock className="w-10 h-10 text-slate-600" data-id="element-168" />,
            title: 'SPEED & CERTAINTY',
            desc: 'We value your time. When we make an offer, we close on it. No delays, no excuses.'
          }, {
            icon: <Heart className="w-10 h-10 text-slate-600" data-id="element-169" />,
            title: 'INTEGRITY',
            desc: 'Honest offers and transparent communication. No hidden fees or last-minute changes.'
          }].map((value, idx) => <div key={idx} className="bg-gray-900 p-8 border border-gray-800 hover:border-slate-600 transition-colors group" data-id="element-170">
                <div className="mb-6 p-3 bg-black border border-gray-700 inline-block group-hover:border-slate-600 transition-colors" data-id="element-171">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold mb-4 uppercase tracking-wide" data-id="element-172">
                  {value.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-173">{value.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-174" />
    </div>;
}